import useStrings from "../../../../localization/useStrings"
import svg from "../../../../utils/svg"
import styles from "./FeaturesList.module.scss"
import { SeasonalPaywallColors } from "../../SeasonalPaywall"

interface FeaturesListProps {
  colors: SeasonalPaywallColors
}

const FeaturesList = ({ colors }: FeaturesListProps) => {
  const strings = useStrings()

  const features = [
    {
      icon: <svg.featureIcons.Star style={{ fill: colors.features.icon }} />,
      title: strings.summerSale.features.premiumFeature.title,
      description: strings.summerSale.features.premiumFeature.description,
    },
    {
      icon: (
        <svg.featureIcons.CloudVault style={{ fill: colors.features.icon }} />
      ),
      title: strings.summerSale.features.cloudVault.title,
      description: strings.summerSale.features.cloudVault.description,
    },
    {
      icon: <svg.featureIcons.Adfree style={{ fill: colors.features.icon }} />,
      title: strings.summerSale.features.noAds.title,
      description: strings.summerSale.features.noAds.description,
    },
    {
      icon: (
        <svg.featureIcons.FacedownLock style={{ fill: colors.features.icon }} />
      ),
      title: strings.summerSale.features.faceDownLock.title,
      description: strings.summerSale.features.faceDownLock.description,
    },
    {
      icon: <svg.featureIcons.Breakin style={{ fill: colors.features.icon }} />,
      title: strings.summerSale.features.breakInReports.title,
      description: strings.summerSale.features.breakInReports.description,
    },
  ]

  return (
    <div className={styles.container}>
      {features.map((feature, index) => (
        <div key={index} className={styles.featureItem}>
          <div className={styles.icon}>{feature.icon}</div>
          <div className={styles.content}>
            <h3
              className={styles.title}
              style={{ color: colors.features.title }}
            >
              {feature.title}
            </h3>
            <p
              className={styles.description}
              style={{ color: colors.features.description }}
            >
              {feature.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default FeaturesList
